// 唤起ios应用的安全域名
export const UNIVERSAL_LINKS = 'upapp.izuiyou.com';

// 唤起 android schema
export const UNIVERSAL_SCHEMA = 'genpai://';

// 请求自带参数
export const POST_INFO = {};

// 请求地址前缀
export const FETCH_HOST = 'https://api.izuiyou.com';

// app下载链接
export const DOWNLOAD = {
  ios: 'https://itunes.apple.com/cn/app/UP/id1337480238?mt=8',
  android: 'https://apk.izuiyou.com/up/download/up-me.apk',
  yyb: 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.xiaochuankeji.genpai',
};


// WEBPACK FOOTER //
// ./src/constants.js